"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stringReplace_1 = require("./util/stringReplace");
var rxjs_1 = require("rxjs");
var Listener = /** @class */ (function () {
    function Listener(fetchBy, persist, callback) {
        if (persist === void 0) { persist = true; }
        this.fetchBy = fetchBy;
        this.callback = callback;
        this.uid = 'uid_' + String(++Listener.lastUid);
        this.persist = persist;
        this.subject = new rxjs_1.ReplaySubject();
    }
    Listener.prototype.matchEvent = function (e) {
        var resume = e.resume();
        var param = typeof this.fetchBy === 'object' ? Listener.composeRegex(this.fetchBy) : stringReplace_1.stringReplace(this.fetchBy);
        return new RegExp(param).test(resume.action) ? this.handler(e) : null;
    };
    Listener.prototype.handler = function (e) {
        if (this.callback) {
            this.callback(e.resume());
        }
        else {
            this.subject.next(e.resume());
        }
        return e;
    };
    Listener.composeRegex = function (_a) {
        var application = _a.application, event = _a.event, type = _a.type;
        return Listener.notNull(application) + "-?" + Listener.notNull(event) + "-?" + Listener.notNull(type);
    };
    Listener.notNull = function (value) {
        return value ? stringReplace_1.stringReplace(value) : '.*';
    };
    Listener.destroy = function () {
        this.lastUid = 0;
    };
    Listener.lastUid = 0;
    return Listener;
}());
exports.Listener = Listener;
